<template>
  <!-- addNewAgency Modal -->
  <div
    class="modal fade"
    id="addNewAgencyModal"
    tabindex="-1"
    aria-labelledby="addNewAgencyModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addNewAgencyModalLabel">
            Add New Agency
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="cancel"
          ></button>
        </div>
        <form @submit.prevent>
          <div class="modal-body">
            <div class="mb-3">
              <label for="agencyId" class="form-label">Agency ID<span style="color: red;"> *</span></label>
              <input
                type="text"
                class="form-control"
                id="agencyId"
                v-model="agencyId"
                required
              />
            </div>
            <div class="mb-3">
              <label for="agencyName" class="form-label">Agency Name<span style="color: red;"> *</span></label>
              <input
                type="text"
                class="form-control"
                id="agencyName"
                v-model="agencyName"
                required
              />
            </div>
            <div class="mb-3">
              <label for="agencySftpUsername" class="form-label">Agency SFTP Username<span style="color: red;"> *</span></label>
              <input
                type="text"
                class="form-control"
                id="agencySftpUsername"
                v-model="agencySftpUsername"
                onkeypress="return event.charCode != 32"
                @focus="touched = true"
                required
              />
              <small v-if="touched && !isValid" class="text-danger">Input should contain characters without blank spaces.</small>
            </div>
            <div class="mb-3">
              <label for="proxyId" class="form-label">Proxy ID</label>
              <select id="proxyId" class="form-select" v-model="proxyId">
                <option value="default">No Proxy Selected</option>
                <option v-for="item in agencyList">{{ item.proxyId }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="proxyName" class="form-label">Proxy Name</label>
              <input
                type="text"
                class="form-control"
                id="proxyName"
                v-model="proxyName"
                disabled
                readonly
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              style="width: 48.5%"
              data-bs-dismiss="modal"
              @click="cancel"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-success"
              style="width: 48.5%"
              :data-bs-dismiss=dismissModal()
              @click="submit"
            >
              Confirm
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useAgencyStore } from "@/stores/agency";

const agencyStore = useAgencyStore();
const agencyList = ref();
const agencyId = ref('');
const agencyName = ref('');
const agencySftpUsername = ref('');
const proxyId = ref('default');
const proxyName = ref(null);

watch(
  () => agencyStore.afterProcessAgency,
  () => {
    agencyStore.fetchProxyAgency();
    agencyList.value = agencyStore.proxyAgency;
  }
)

watch(
  () => proxyId.value,
  (proxyId) => {
    proxyName.value = null; // Reset foundValue
    for (const obj of agencyList.value) {
      if (obj.proxyId === proxyId) {
        proxyName.value = obj.proxyName;
        break;
      }
    }
  }
)

watch(() => agencyStore.errorModalVisible, (visible) => {
  if (visible) {
    agencyId.value = agencyStore.newAgency.id;
    agencyName.value = agencyStore.newAgency.name;
    agencySftpUsername.value = agencyStore.newAgency.sftpUsername;
    if(agencyStore.newAgency.proxyId) {
      proxyId.value = agencyStore.newAgency.proxyId;
      proxyName.value = agencyStore.newAgency.proxyName;
    }
  } else {
    agencyId.value = '';
    agencyName.value = '';
    agencySftpUsername.value = '';
    proxyId.value = 'default';
    proxyName.value = null;
  }
});

const cancel = () => {
  agencyId.value = '';
  agencyName.value = '';
  agencySftpUsername.value = '';
  proxyId.value = 'default';
  proxyName.value = null;
  touched.value = false;
  agencyStore.closeAddNewModal();
}

const trimUsername = ref("")
const isValid = ref(true);
const touched = ref(false);

const dismissModal = () => {
  trimUsername.value = agencySftpUsername.value.trim();
  if (!(agencyId.value == '' || agencyName.value == '' || trimUsername.value == '')) {
    agencyStore.closeAddNewModal();
    return "modal"
  }
};

const submit = async () => {
  trimUsername.value = agencySftpUsername.value.trim();
  isValid.value = !/^\s*$/.test(trimUsername.value);
  if (!(agencyId.value == '' || agencyName.value == '' || trimUsername.value == '')) {
    if(proxyId.value == 'default'){
      let newAgency = {
        active: true,
        id: agencyId.value,
        name: agencyName.value,
        sftpUsername: agencySftpUsername.value,
      }
      await agencyStore.addAgency(newAgency);
    } else {
      let newAgency = {
        active: true,
        id: agencyId.value,
        name: agencyName.value,
        sftpUsername: agencySftpUsername.value,
        proxyId: proxyId.value,
        proxyName: proxyName.value,
      }
      await agencyStore.addAgency(newAgency);
    }
    agencyId.value = '';
    agencyName.value = '';
    agencySftpUsername.value = '';
    proxyId.value = 'default';
    proxyName.value = null;
  } 
};
</script>

<style scoped>
li {
  padding-right: 10px;
  margin: auto;
  display: inline-block;
}
</style>
